import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import './dataintegration.css'

export const Dataintegration = () => {
  return (
    <div>
      <section style={{ marginTop: '5rem' }} className='py-3'>
        <Container>
          <div className="data-integration-outer">
            <div className="data-main-inner">
              <Row className='align-items-center justify-content-center py-2'>
                <Col lg={10}>
                  <h5 className='head-fot-di'>
                    Discover the Power of Data Integration
                  </h5>
                  <p>
                    Smart Integraphics application offers a wide range of connectors for various data sources. These include file formats such as Excel, CSV, TXT, JSON, and XML. For databases, it supports SQL, Oracle, MySQL, MongoDB, and PostgreSQL. Additionally, it integrates seamlessly with popular ERP systems like SAP, Oracle, Microsoft Dynamics, S/4HANA, and IFS. With such a diverse set of integration options, Smart Integraphics provides users with extensive flexibility and versatility for their data analytics needs
                  </p>
                </Col>
              </Row>

            </div>
          </div>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='align-items-center justify-content-center d-flex'>
            <Col lg={12} className='text-start data-third-sec '>
              <div className="d-flex align-items-start justify-contnet-between">
                <div className="data-slide-integra"></div>
                <div className="mx-3">
                  <h5 className='head-fot-di'>Databases</h5>
                  <p>
                    Smart Integraphics' wide range of database connectors enables seamless integration with diverse systems, such as SQL, Oracle, MySQL, MongoDB, and PostgreSQL. This flexibility allows businesses to combine data from multiple sources for centralized and real-time analytics. It improves decision-making by providing accurate, up-to-date insights while ensuring data consistency. The system reduces manual data extraction efforts, saving time and costs. Additionally, it supports scalability and adapts to evolving business needs, enhancing overall efficiency
                  </p>
                </div>

              </div>

            </Col>
            <Col lg={12}>
              <img src={require('../assets/data-integration/Databases-Images2.png')} className='w-50' alt='database' />
              {/* <img src='https://smartintegraphics.com/assets/data-integration/Databases-Images2.png' className='w-50' alt='database' /> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='align-items-center justify-content-center d-flex'>
            <Col lg={12} className='text-start data-third-sec '>
              <div className="d-flex align-items-start justify-contnet-between">
                <div className="data-slide-integra"></div>
                <div className="mx-3">
                  <h5 className='head-fot-di'>Enterprise Resource Planning (ERP) Systems:</h5>
                  <p>
                    Comprehensive data from ERP solutions like SAP, Oracle ERP, and Microsoft Dynamics is essential for managing core business processes such as finance, HR, and supply chain. These systems integrate data across departments, providing a unified view that improves decision-making, enhances efficiency, and fosters collaboration. By leveraging ERP data, businesses can optimize resources, reduce costs, and drive growth.
                  </p>
                </div>

              </div>

            </Col>
            <Col lg={12}>
            <img src={require('../assets/data-integration/ERP-Systems-Images2.png')} className='w-50' alt='database' />

              {/* <img src='https://smartintegraphics.com/assets/data-integration/ERP-Systems-Images2.png' className='w-50' alt='database' /> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='align-items-center justify-content-center d-flex'>
            <Col lg={12} className='text-start data-third-sec '>
              <div className="d-flex align-items-start justify-contnet-between">
                <div className="data-slide-integra"></div>
                <div className="mx-3">
                  <h5 className='head-fot-di'>Files</h5>
                  <p>
                    Unstructured and semi-structured data from file formats like CSV, Excel, JSON, and XML contain valuable insights for analysis. These formats capture diverse information, from simple tables to complex structures, enabling businesses to uncover patterns, identify trends, and make informed decisions. Properly managing and integrating this data with structured data enhances analysis and drives better performance and competitive advantage.
                  </p>
                </div>

              </div>

            </Col>

            <Col lg={12}>
              <img src={require('../assets/data-integration/Files-Images2.png')} className='w-50' alt='database' />
              {/* <img src='https://smartintegraphics.com/assets/data-integration/Files-Images2.png' className='w-50' alt='database' /> */}
            </Col>

          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='align-items-center justify-content-center d-flex'>
            <Col lg={12} className='text-start data-third-sec  '>
              <div className="d-flex align-items-start justify-contnet-between">
                <div className="data-slide-integra"></div>
                <div className="mx-3">
                  <h5 className='head-fot-di'>Cloud Storage</h5>
                  <p>
                    Data stored in cloud solutions like AWS, Google Cloud, and Azure provides flexibility and scalability, making it easy to integrate diverse data sources. These platforms offer secure, cost-effective storage and real-time access, enabling businesses to optimize operations and make faster, data-driven decisions. Additionally, cloud solutions support seamless collaboration and innovation across teams, driving overall business growth.
                  </p>
                </div>
              </div>
            </Col>
            <Col lg={12} className=''>
              <img src={require('../assets/data-integration/Cloud-Storage-Images2.png')} className='w-50' alt='database' />
              {/* <img src='https://smartintegraphics.com/assets/data-integration/Cloud-Storage-Images2.png' className='w-50' alt='database' /> */}
            </Col>


          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='d-flex align-items-center justify-content-center'>
            <Col lg={12} className='text-start data-third-sec '>
              <div className="d-flex align-items-start justify-contnet-between">
                <div className="data-slide-integra"></div>
                <div className="mx-3 ">
                  <h5 className='head-fot-di'>Image and Videos</h5>
                  <p>
                    Multimedia data from video files and streaming platforms provides valuable insights through visual content analysis and audience engagement metrics. It helps businesses uncover trends, optimize content strategies, and enhance customer experiences, driving greater engagement and brand loyalty. By analyzing this data, companies can tailor content to specific audiences, improving targeting and increasing the effectiveness of marketing campaigns.
                  </p>
                </div>

              </div>

            </Col>
            <Col lg={12}>
              <img src={require('../assets/data-integration/Image-and-Videos-Images2.png')} className='w-50' alt='database' />
              {/* <img src='https://smartintegraphics.com/assets/data-integration/Image-and-Videos-Images2.png' className='w-50' alt='database' /> */}
            </Col>
          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='align-items-center justify-content-center d-flex'>

            <Col lg={12} className='text-start data-third-sec'>
              <div className="d-flex align-items-start justify-contnet-between">
                <div className="data-slide-integra"></div>
                <div className="mx-3">
                  <h5 className='head-fot-di'>Social media</h5>
                  <p>
                    Data extraction from social media platforms like Facebook, YouTube, LinkedIn, and Twitter uses their APIs to gather user profiles, posts, and engagement metrics. This enables businesses to analyze trends, track sentiment, refine marketing strategies, and drive engagement by understanding customer behavior and preferences. Additionally, it allows companies to identify emerging trends, monitor brand health, and create more targeted campaigns.
                  </p>
                </div>

              </div>

            </Col>
            <Col lg={12}>
              <img src={require('../assets/data-integration/SOcial-media-Images2.png')} className='w-50' alt='database' />
              {/* <img src='https://smartintegraphics.com/assets/data-integration/SOcial-media-Images2.png' className='w-50' alt='database' /> */}
            </Col>

          </Row>
        </Container>
      </section>

      <section>
        <Container>
          <Row className='align-items-center d-flex justify-content-center'>
            <Col lg={8} >
              <h5 className='head-fot-di'>
                APIs and Web Services
              </h5>
              <p >
                Data from external applications and services accessed via APIs (Application Programming Interfaces),
                allowing integration with third-party systems and cloud services
              </p>
              <p >
                Data obtained from web services, including social media platforms and online
                surveys, which can enrich understanding of Customer behavior and market trends.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

    </div>
  )
}
